import React, { useEffect, useState } from "react";
import { Container, Table } from "react-bootstrap";
import { TextField, Typography } from "@mui/material";
import TableContent from "../../table/table";
import Loader from "../../../loader/loader";
import { useDispatch, useSelector } from "react-redux";
import { GetAllEmployeeAction } from "../../../../redux/actions/employeeActions";
const NEMPsearch = () => {
  const dispatch = useDispatch();
  const All = useSelector((state) => state.EmployeeR.GetEmployee);
  const [Search, setSearch] = useState("");
  const PageSize = 7;
  useEffect(() => {
    dispatch(GetAllEmployeeAction(`SearchTerm=${Search}&PageSize=${PageSize}`));
  }, [Search]);
  const onPress = async (page) => {
    await dispatch(
      GetAllEmployeeAction(`PageNumber=${page}&PageSize=${PageSize}`)
    );
  };
  const [Filee, setFilee] = useState([]);
  const [FileeBase64, setBase64] = useState("");
  function formatFileSize(bytes) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  }

  function importData() {
    let input = document.createElement("input");
    input.type = "file";
    input.multiple = "true";
    input.onchange = (e) => {
      let files = e.target.files;
      // const fileArray = Array.from(files);
      setFilee([...Filee, files]);

      // const reader = new FileReader();
      // reader.readAsDataURL(file);
      // reader.onloadend = () => {
      //   setBase64(reader.result);
      // };
    };

    input.click();
  }
  const deleteFile = (idx) => {
    const newelement = Filee.filter((fil, index, arr) => index !== idx);
    setFilee(newelement);
    setBase64("");
  };
  return (
    <>
      <div className="enterr">
        <Container>
          <div className="inp-container">
            <TextField
              label={"ابحث"}
              variant="outlined"
              //   className="ww"
            />
          </div>
          {/* <div className="inputs-container">
            <div className="inp-container ">
              {" "}
              <TextField
                
                label="ابحث"
                variant="outlined"
                //   className="ww"
              />
              <i className="ty fa-solid fa-magnifying-glass"></i>
            </div>{" "}
            <div className="inp-container"></div>
            <div className="inp-container"></div>
          </div> */}
        </Container>{" "}
        {/* <Table
          id="my-table"
          className="maint"
          responsive
          striped
          bordered
          hover>
          <thead>
            <tr>
              <th>
                اسم الموظف <i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                الأدارة <i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                المسمى الوظيفي <i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                رقم الهاتف <i className="fa-regular fa-calendar-check"></i>
              </th>
              <th>
                حضور <i className="fa-regular fa-calendar-check"></i>
              </th>
              <th>
                انصراف <i className="fa-regular fa-calendar-check"></i>
              </th>
              <th>
                أيام العمل الأسبوعية{" "}
                <i className="fa-regular fa-calendar-check"></i>
              </th>
              <th>
                ارشيف المستندات <i className="fa-regular fa-calendar-check"></i>
              </th>
              <th className="icon-w"> </th>
              <th className="icon-w"> </th>
              <th className="icon-w"> </th>
            </tr>
          </thead>
          <tbody>
            {All && All.data && All.data.length > 0
              ? All.data.map((item, idx) => {
                  // ForceCount = ALL.TotalPages - 1;
                  return (
                    <tr key={idx} onDoubleClick={() => Update(item)}>
                      <td>{item.name}</td>
                      <td>{item.department}</td>
                      <td>{item.jopTitle}</td>
                      <td>{item.phoneNumber}</td>
                      <td>{item.presence}</td>
                      <td>{item.departure}</td>
                      <td>{item.workingDays}</td>
                      <td>
                        {" "}
                        {item.fileUrl !== null ? (
                          <>
                            <button
                              style={{
                                backgroundColor: "transparent",
                                border: "none",
                              }}
                              onClick={() => handleShowpopup(item.fileUrl)}>
                              {" "}
                              <i className="fa-solid fa-paperclip"></i>
                            </button>
                            <span>{item.fileDescription}</span>
                          </>
                        ) : (
                          " "
                        )}
                      </td>
                      <td className="icon-w" onClick={() => Update(item)}>
                        <i
                          className="fa fa-solid fa-pen-to-square icon-blue"
                          style={{ color: "#333" }}></i>
                      </td>
                      <td className="icon-w">
                        {" "}
                        <i
                          onClick={() => handleShoweDelete(item.id)}
                          className="fs fa-solid fa-trash-can icon-red"
                          style={{ color: "#333" }}></i>
                      </td>
                      <td className="icon-w">
                        <i
                          onClick={() => Showw(item)}
                          className="fa-solid fa-eye"
                          style={{ color: "#333" }}></i>
                      </td>
                    </tr>
                  );
                })
              : null}
          </tbody>
        </Table>
          <ToastContainer autoClose={1200} />
        <Pagination
          onPress={onPress}
          PageSize={PageSize}
          PageCount={All ? All.totalPages : null}
          // ForceCount={ForceCount}
          // itemsPerPage={2}
          // items={FilesDetails.data}
        /> */}
      </div>
    </>
  );
};
const names = [{ name: "ahmed" }, { name: "salama" }];
export default NEMPsearch;
